import script from "./AddonsMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddonsMain.vue?vue&type=script&setup=true&lang=ts"

import "./AddonsMain.vue?vue&type=style&index=0&id=252245a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252245a8"]])

export default __exports__